import * as Sentry from '@sentry/react';
import get from 'lodash/get';
import { Integrations } from '@sentry/tracing';
import history from 'react-router/lib/browserHistory';
import { extractHostname } from './extractHostname';
import {
  API_URI,
  DEV_ENV,
  ENV_NAME,
  SENTRY_CLIENT_DNS,
} from '../../constants/env';

const isDevelopment = DEV_ENV;
// const isDevelopment = false;

if (!isDevelopment) {
  console.log('INITIATE SENTRY!');
  Sentry.init({
    dsn: SENTRY_CLIENT_DNS,
    environment: ENV_NAME,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [extractHostname(API_URI)],
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    tracesSampleRate: 1.0,
    normalizeDepth: 5,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'fetch') return null;
      if (breadcrumb.category === 'xhr') {
        const url = get(breadcrumb, 'data.url', '') || '';
        return url.includes(API_URI) ? breadcrumb : null;
      }
      if (breadcrumb.category === 'ui.click') return null;
      if (breadcrumb.category === 'ui.input') return null;
      if (breadcrumb.category === 'console') return null;

      return breadcrumb;
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/sentry/index.js